import React from 'react';
import { Button } from '@material-ui/core';
import { makeStyles, createStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => createStyles({
    root: {
      '& > *': {
        margin: theme.spacing(1),
        width: '40%',
      },
    },
  }));

function ActionButtons(props) {
  const classes = useStyles();
  const { leftAction, leftText, rightAction, rightText, leftDisabled, rightDisabled } = props;
  return (
    <div className={classes.root}>
      {leftText && (
        <Button onClick={leftAction} variant="outlined" color="primary" disabled={leftDisabled}>
          {leftText}
        </Button>
      )}
      <Button onClick={rightAction} variant="outlined" color="secondary" disabled={rightDisabled}>
        {rightText}
      </Button>
    </div>
  );
}

export default ActionButtons;
